<script setup>
import { ref, onMounted, defineProps } from 'vue';
import { useDateFormat } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import axios from 'axios';

const { t } = useI18n({ useScope: 'global' });

const { src, isFaceMathed, isSpoofed, id, created, original } = defineProps({
    src: {
        type: String,
        default: '',
    },
    id: {
        type: String,
    },
    isFaceMathed: {
        type: Boolean,
        default: false,
    },
    isSpoofed: {
        type: Boolean,
        default: false,
    },
    created: {
        type: Number,
    },
    original: {
        type: String,
        default: '',
    },
});

const userDetection = ref(null);
const userSpoofed = ref(null);

// const faceDetection = async (img1, img2) => {
//     try {
//         const { data } = await axios.post(`http://10.20.10.121:8000/api/v1/compare`, {
//             image1: img1,
//             image2: img2,
//             image1_type: 'url',
//             image2_type: 'url',
//             model: 'MagFace-R100',
//             metric: 'cosine',
//             threshold: 0.5,
//             enable_antispoof: true,
//         });

//         // Обновляем значения на основе нового ответа
//         userDetection.value = data.verified;
//         userSpoofed.value = !data.antispoof_results.image2.is_real;

//         return data;
//     } catch (error) {
//         console.error('Face detection error:', error);
//         return null;
//     }
// };
onMounted(async () => {
    await faceDetection(original, src);
});
</script>

<template>
    <a :data-fancybox="'gallery' + id" :data-src="src" class="fancybox-wrapper">
        <img :src="src" alt="image" class="gallery" :class="isFaceMathed === null || isSpoofed === null ? 'blur-sm' : ''" />
        <span
            :class="['icon-wrapper left', isSpoofed === null || isSpoofed ? 'danger' : 'success']"
            v-tooltip.top="{
                value: isSpoofed ? t('profile.isSpoofed') : t('profile.isNotSpoofed'),
                pt: {
                    text: '!bg-primary text-xs',
                },
            }"
        >
            <Icon name="smile" class="spoofied" />
        </span>
        <span
            :class="['icon-wrapper right', isFaceMathed ? 'success' : 'danger']"
            v-tooltip.top="{
                value: isFaceMathed ? t('profile.faceMatched') : t('profile.faceNotMatched'),
                pt: {
                    text: '!bg-primary text-xs',
                },
            }"
        >
            <Icon name="facematched" class="facematched" />
        </span>
        <span class="created">
            {{ created ? useDateFormat(created, 'HH:mm:ss').value : '-' }}
        </span>
        <!-- <div class="flex items-center justify-center">
            <span class="flex items-center justify-center w-full text-xs text-white" :class="!userSpoofed ? 'bg-green-500' : 'bg-red-500'"> {{ userSpoofed ? 'Spoofed' : 'Real' }}</span>
            <span class="flex items-center justify-center w-full text-xs text-white" :class="userDetection ? 'bg-green-500' : 'bg-red-500'">{{ userDetection ? 'Verified' : 'Not Verified' }}</span>
        </div> -->
    </a>
</template>

<style scoped>
.fancybox-wrapper {
    @apply relative w-fit cursor-pointer;
}
.gallery {
    @apply w-[80px] h-[80px] object-cover;
}
.icon-wrapper {
    @apply w-[18px] h-[18px] flex justify-center items-center rounded-full absolute;
}
.right {
    @apply top-1 right-1;
}
.left {
    @apply top-1 left-1;
}
.icon-wrapper.success {
    @apply bg-[#34C759];
}
.icon-wrapper.danger {
    @apply bg-[#FF4747];
}
:deep(.facematched),
:deep(.spoofied) {
    @apply w-3 h-3 text-white;
}
.created {
    @apply absolute bottom-1 right-1 text-xs text-white bg-black p-0.5;
}
</style>
